// components/skeletons/SubscriptionSkeleton.jsx
import React from "react";
import Header from "../header/Header";
import Sidebar from "../sidebar/Sidebar";
import "./SubscriptionSkeleton.css";

const SubscriptionSkeleton = () => {
  return (
    <div className="dashboard-layout">
      <Header />
      <Sidebar />
      <div className="dashboard-content subscription-page">

        {/* Title */}
        <div className="skel skel-title" />
        <div className="skel skel-subtitle" />

        {/* Banner placeholder */}
        <div className="skel skel-banner" />

        {/* Toggle */}
        <div className="skel-toggle-row">
          <div className="skel skel-toggle-btn" />
          <div className="skel skel-toggle-btn" />
        </div>

        {/* Plan cards */}
        <div className="skel-plans-grid">
          {[1, 2].map((i) => (
            <div key={i} className="skel-plan-card">
              <div className="skel-plan-header">
                <div className="skel skel-plan-badge" />
                <div className="skel skel-plan-price" />
                <div className="skel skel-plan-desc" />
              </div>
              <div className="skel-plan-body">
                <div className="skel skel-plan-btn" />
                <div className="skel skel-feature" />
                <div className="skel skel-feature short" />
                <div className="skel skel-feature" />
                <div className="skel skel-feature short" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSkeleton;